import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AppSetting = Node & {
  __typename?: 'AppSetting';
  id: Scalars['ID'];
  isPublic?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** A connection to a list of items. */
export type AppSettingConnection = {
  __typename?: 'AppSettingConnection';
  /** Information to aid in pagination */
  edges?: Maybe<Array<Maybe<AppSettingEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection */
export type AppSettingEdge = {
  __typename?: 'AppSettingEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AppSetting>;
};

export type AppSettingInput = {
  /** The primary key for input is always id. */
  id?: InputMaybe<Scalars['Int']>;
  isPublic: Scalars['Boolean'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type BlogCategory = Node & {
  __typename?: 'BlogCategory';
  id: Scalars['ID'];
  lang?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** A connection to a list of items. */
export type BlogCategoryConnection = {
  __typename?: 'BlogCategoryConnection';
  /** Information to aid in pagination */
  edges?: Maybe<Array<Maybe<BlogCategoryEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection */
export type BlogCategoryEdge = {
  __typename?: 'BlogCategoryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<BlogCategory>;
};

export type BlogCategoryInput = {
  /** The primary key for input is always id. */
  id?: InputMaybe<Scalars['Int']>;
  lang: Scalars['String'];
  title: Scalars['String'];
};

export type BlogPost = Node & {
  __typename?: 'BlogPost';
  body?: Maybe<Scalars['String']>;
  category?: Maybe<BlogCategory>;
  datum?: Maybe<Scalars['Int']>;
  descript?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idBlog: Scalars['ID'];
  idCateg?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** A connection to a list of items. */
export type BlogPostConnection = {
  __typename?: 'BlogPostConnection';
  /** Information to aid in pagination */
  edges?: Maybe<Array<Maybe<BlogPostEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection */
export type BlogPostEdge = {
  __typename?: 'BlogPostEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<BlogPost>;
};

export type BlogPostInput = {
  body: Scalars['String'];
  datum: Scalars['Int'];
  descript: Scalars['String'];
  /** The primary key for input is always id. */
  id?: InputMaybe<Scalars['Int']>;
  idCateg: Scalars['Int'];
  image: Scalars['String'];
  lang: Scalars['String'];
  status: Scalars['String'];
  tags: Scalars['String'];
  title: Scalars['String'];
};

export type DeleteAppSetting = {
  __typename?: 'DeleteAppSetting';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteBlogCategory = {
  __typename?: 'DeleteBlogCategory';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteBlogPost = {
  __typename?: 'DeleteBlogPost';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteGroup = {
  __typename?: 'DeleteGroup';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteMart = {
  __typename?: 'DeleteMart';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteMenu = {
  __typename?: 'DeleteMenu';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeletePaymentMethod = {
  __typename?: 'DeletePaymentMethod';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteProduct = {
  __typename?: 'DeleteProduct';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteProductCategory = {
  __typename?: 'DeleteProductCategory';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteUserNode = {
  __typename?: 'DeleteUserNode';
  success?: Maybe<Scalars['Boolean']>;
};

export type FacebookConversionApiInput = {
  eventName: Scalars['String'];
  eventSourceUrl: Scalars['String'];
  /** The custom data parameters and custom properties as a JSON string. See: https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/custom-data */
  parameters?: InputMaybe<Scalars['String']>;
  /** The customer information parameters as a JSON string. https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/customer-information-parameters */
  userParameters?: InputMaybe<Scalars['String']>;
};

export type Group = Node & {
  __typename?: 'Group';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** A connection to a list of items. */
export type GroupConnection = {
  __typename?: 'GroupConnection';
  /** Information to aid in pagination */
  edges?: Maybe<Array<Maybe<GroupEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection */
export type GroupEdge = {
  __typename?: 'GroupEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Group>;
};

export type GroupInput = {
  /** The primary key for input is always id. */
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type LoginFacebookUser = {
  __typename?: 'LoginFacebookUser';
  refreshToken?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<UserNode>;
};

export type LoginGoogleUser = {
  __typename?: 'LoginGoogleUser';
  refreshToken?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<UserNode>;
};

export type Mart = Node & {
  __typename?: 'Mart';
  awb?: Maybe<Scalars['String']>;
  bookName?: Maybe<Scalars['String']>;
  bookmark?: Maybe<Scalars['String']>;
  chartTax?: Maybe<Scalars['Float']>;
  cod?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  curier?: Maybe<Scalars['String']>;
  dateOrd?: Maybe<Scalars['Int']>;
  factCegnev?: Maybe<Scalars['String']>;
  factCim?: Maybe<Scalars['String']>;
  factCodfisc?: Maybe<Scalars['String']>;
  factEmail?: Maybe<Scalars['String']>;
  factFullname?: Maybe<Scalars['String']>;
  factIsceg?: Maybe<Scalars['Int']>;
  factMegye?: Maybe<Scalars['String']>;
  factNrord?: Maybe<Scalars['String']>;
  factPostakod?: Maybe<Scalars['String']>;
  factTelefon?: Maybe<Scalars['String']>;
  factVaros?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idUser?: Maybe<Scalars['Int']>;
  kupon?: Maybe<Scalars['String']>;
  kupond?: Maybe<Scalars['Float']>;
  nrOrd?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Int']>;
  paymentMethod?: Maybe<PaymentMethod>;
  ramb1?: Maybe<Scalars['Int']>;
  ramb2?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  statuschange?: Maybe<Scalars['Int']>;
  szk?: Maybe<Scalars['Float']>;
  tipus?: Maybe<Scalars['Int']>;
  trans1?: Maybe<Scalars['Int']>;
  trans2?: Maybe<Scalars['Int']>;
  trans3?: Maybe<Scalars['String']>;
  transCim?: Maybe<Scalars['String']>;
  transFullname?: Maybe<Scalars['String']>;
  transMegye?: Maybe<Scalars['String']>;
  transPostakod?: Maybe<Scalars['String']>;
  transTelefon?: Maybe<Scalars['String']>;
  transVaros?: Maybe<Scalars['String']>;
  ufiz?: Maybe<Scalars['String']>;
  uzlet?: Maybe<Scalars['Int']>;
};

/** A connection to a list of items. */
export type MartConnection = {
  __typename?: 'MartConnection';
  /** Information to aid in pagination */
  edges?: Maybe<Array<Maybe<MartEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection */
export type MartEdge = {
  __typename?: 'MartEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Mart>;
};

export type MartInput = {
  /** The primary key for input is always id. */
  id?: InputMaybe<Scalars['Int']>;
};

export type Menu = Node & {
  __typename?: 'Menu';
  extUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idMenu: Scalars['ID'];
  itemId?: Maybe<Scalars['Int']>;
  linkTo?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  ordered?: Maybe<Scalars['Int']>;
  parent?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

/** A connection to a list of items. */
export type MenuConnection = {
  __typename?: 'MenuConnection';
  /** Information to aid in pagination */
  edges?: Maybe<Array<Maybe<MenuEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection */
export type MenuEdge = {
  __typename?: 'MenuEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Menu>;
};

export type MenuInput = {
  extUrl?: InputMaybe<Scalars['String']>;
  /** The primary key for input is always id. */
  id?: InputMaybe<Scalars['Int']>;
  itemId: Scalars['Int'];
  linkTo: Scalars['String'];
  location: Scalars['String'];
  ordered?: InputMaybe<Scalars['Int']>;
  parent: Scalars['Int'];
  status: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  deleteAppSetting?: Maybe<DeleteAppSetting>;
  deleteBlogCategory?: Maybe<DeleteBlogCategory>;
  deleteBlogPost?: Maybe<DeleteBlogPost>;
  deleteGroup?: Maybe<DeleteGroup>;
  deleteMart?: Maybe<DeleteMart>;
  deleteMenu?: Maybe<DeleteMenu>;
  deletePaymentMethod?: Maybe<DeletePaymentMethod>;
  deleteProduct?: Maybe<DeleteProduct>;
  deleteProductCategory?: Maybe<DeleteProductCategory>;
  deleteUser?: Maybe<DeleteUserNode>;
  /** Register or login a user with the Facebook Login SDK. */
  loginFacebookUser?: Maybe<LoginFacebookUser>;
  /** Register or login a user with the Sign in with Google SDK. */
  loginGoogleUser?: Maybe<LoginGoogleUser>;
  /** Reset the password with a token received in email. */
  passwordReset?: Maybe<PasswordReset>;
  refreshToken?: Maybe<RefreshToken>;
  register?: Maybe<Register>;
  /** Not implemented */
  resendActivationEmail?: Maybe<ResendActivationEmail>;
  saveAppSetting?: Maybe<SaveAppSetting>;
  saveBlogCategory?: Maybe<SaveBlogCategory>;
  saveBlogPost?: Maybe<SaveBlogPost>;
  saveGroup?: Maybe<SaveGroup>;
  saveMart?: Maybe<SaveMart>;
  saveMenu?: Maybe<SaveMenu>;
  savePaymentMethod?: Maybe<SavePaymentMethod>;
  saveProduct?: Maybe<SaveProduct>;
  saveProductCategory?: Maybe<SaveProductCategory>;
  saveUser?: Maybe<SaveUserNode>;
  /** Should send an email with a token to reset the password. Not implemented */
  sendPasswordResetEmail?: Maybe<SendPasswordResetEmail>;
  /** Set the permissions for a group */
  setPermissionsForGroup?: Maybe<SetPermissionsForGroup>;
  tokenAuth?: Maybe<TokenAuth>;
  /** Track an event with the Facebook Conversion API */
  trackWithFacebookConversionsApi?: Maybe<Scalars['Boolean']>;
  /** Verify an account after register. The token was sent via email to the user. */
  verifyAccount?: Maybe<VerifyAccount>;
  /** Verify a JWT token */
  verifyToken?: Maybe<VerifyToken>;
};


export type MutationDeleteAppSettingArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteBlogCategoryArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteBlogPostArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteGroupArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteMartArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteMenuArgs = {
  id: Scalars['Int'];
};


export type MutationDeletePaymentMethodArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteProductCategoryArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['Int'];
};


export type MutationLoginFacebookUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  facebookLoginId: Scalars['String'];
};


export type MutationLoginGoogleUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  googleLoginId: Scalars['String'];
};


export type MutationPasswordResetArgs = {
  newPassword1: Scalars['String'];
  newPassword2: Scalars['String'];
  token: Scalars['String'];
};


export type MutationRefreshTokenArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRegisterArgs = {
  email: Scalars['String'];
  password1: Scalars['String'];
  password2: Scalars['String'];
  username: Scalars['String'];
};


export type MutationResendActivationEmailArgs = {
  email: Scalars['String'];
};


export type MutationSaveAppSettingArgs = {
  input: AppSettingInput;
};


export type MutationSaveBlogCategoryArgs = {
  input: BlogCategoryInput;
};


export type MutationSaveBlogPostArgs = {
  input: BlogPostInput;
};


export type MutationSaveGroupArgs = {
  input: GroupInput;
};


export type MutationSaveMartArgs = {
  input: MartInput;
};


export type MutationSaveMenuArgs = {
  input: MenuInput;
};


export type MutationSavePaymentMethodArgs = {
  input: PaymentMethodInput;
};


export type MutationSaveProductArgs = {
  input: ProductInput;
};


export type MutationSaveProductCategoryArgs = {
  input: ProductCategoryInput;
};


export type MutationSaveUserArgs = {
  input: UserInput;
};


export type MutationSendPasswordResetEmailArgs = {
  email: Scalars['String'];
};


export type MutationSetPermissionsForGroupArgs = {
  groupId: Scalars['Int'];
  permissionCodenames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationTokenAuthArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationTrackWithFacebookConversionsApiArgs = {
  input: FacebookConversionApiInput;
};


export type MutationVerifyAccountArgs = {
  token: Scalars['String'];
};


export type MutationVerifyTokenArgs = {
  token: Scalars['String'];
};

/** An object with an ID */
export type Node = {
  /** The id of the object */
  id: Scalars['ID'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PasswordReset = {
  __typename?: 'PasswordReset';
  success?: Maybe<Scalars['Boolean']>;
};

export type PaymentMethod = Node & {
  __typename?: 'PaymentMethod';
  id: Scalars['ID'];
  idPay: Scalars['ID'];
  idTrans?: Maybe<Scalars['Int']>;
  orderNo?: Maybe<Scalars['Int']>;
  p1?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  translation?: Maybe<PaymentMethodTranslation>;
};

/** A connection to a list of items. */
export type PaymentMethodConnection = {
  __typename?: 'PaymentMethodConnection';
  /** Information to aid in pagination */
  edges?: Maybe<Array<Maybe<PaymentMethodEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection */
export type PaymentMethodEdge = {
  __typename?: 'PaymentMethodEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PaymentMethod>;
};

export type PaymentMethodInput = {
  /** The primary key for input is always id. */
  id?: InputMaybe<Scalars['Int']>;
};

export type PaymentMethodTranslation = Node & {
  __typename?: 'PaymentMethodTranslation';
  descript?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idPay?: Maybe<Scalars['Int']>;
  idPl: Scalars['ID'];
  lang?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Permission = Node & {
  __typename?: 'Permission';
  codename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type Product = Node & {
  __typename?: 'Product';
  brandName?: Maybe<Scalars['String']>;
  colorName?: Maybe<Scalars['String']>;
  discEnd?: Maybe<Scalars['Int']>;
  discPer?: Maybe<Scalars['Int']>;
  discStart?: Maybe<Scalars['Int']>;
  discStatus?: Maybe<Scalars['String']>;
  discVal?: Maybe<Scalars['Float']>;
  discopt?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Int']>;
  gyarto?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idProd: Scalars['ID'];
  isindex?: Maybe<Scalars['String']>;
  kedve?: Maybe<Scalars['String']>;
  kifut?: Maybe<Scalars['String']>;
  kod?: Maybe<Scalars['String']>;
  kod2?: Maybe<Scalars['String']>;
  lastmod?: Maybe<Scalars['Int']>;
  mainCategory?: Maybe<ProductCategory>;
  model?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Int']>;
  ordered?: Maybe<Scalars['Int']>;
  parent?: Maybe<Scalars['Int']>;
  parentProduct?: Maybe<Product>;
  pe?: Maybe<Scalars['Float']>;
  prodPrice?: Maybe<Scalars['Float']>;
  prodPrice0?: Maybe<Scalars['Float']>;
  prodPrice2?: Maybe<Scalars['Float']>;
  promo?: Maybe<Scalars['String']>;
  raktar?: Maybe<Scalars['Int']>;
  raktarAct?: Maybe<Scalars['Int']>;
  raktarAct2?: Maybe<Scalars['Int']>;
  raktarDisc?: Maybe<Scalars['Int']>;
  raktarFp?: Maybe<Scalars['Int']>;
  raktarMod?: Maybe<Scalars['String']>;
  rendelheto?: Maybe<Scalars['String']>;
  sing?: Maybe<Scalars['String']>;
  some?: Maybe<Scalars['Int']>;
  specBuc?: Maybe<Scalars['Int']>;
  specPrice?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  suly?: Maybe<Scalars['Float']>;
  tablink?: Maybe<Scalars['String']>;
  trans?: Maybe<Scalars['Float']>;
  translation?: Maybe<ProductTranslation>;
  uj?: Maybe<Scalars['String']>;
  upimage?: Maybe<Scalars['String']>;
  uptime?: Maybe<Scalars['Int']>;
  video?: Maybe<Scalars['String']>;
  vidreplace?: Maybe<Scalars['String']>;
  views?: Maybe<Scalars['Int']>;
};

export type ProductCategory = Node & {
  __typename?: 'ProductCategory';
  googleid?: Maybe<Scalars['String']>;
  hs?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idCateg: Scalars['ID'];
  ikon?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isindex?: Maybe<Scalars['String']>;
  kiem?: Maybe<Scalars['String']>;
  kval?: Maybe<Scalars['String']>;
  lastmod?: Maybe<Scalars['Int']>;
  linkTo?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  location2?: Maybe<Scalars['String']>;
  maxp?: Maybe<Scalars['Int']>;
  ordered?: Maybe<Scalars['Int']>;
  parent?: Maybe<Scalars['Int']>;
  parentCategory?: Maybe<ProductCategory>;
  sectitle?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trans?: Maybe<Scalars['Float']>;
  translation?: Maybe<ProductCategoryTranslation>;
};

/** A connection to a list of items. */
export type ProductCategoryConnection = {
  __typename?: 'ProductCategoryConnection';
  /** Information to aid in pagination */
  edges?: Maybe<Array<Maybe<ProductCategoryEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection */
export type ProductCategoryEdge = {
  __typename?: 'ProductCategoryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductCategory>;
};

export type ProductCategoryInput = {
  /** The primary key for input is always id. */
  id?: InputMaybe<Scalars['Int']>;
};

export type ProductCategoryTranslation = Node & {
  __typename?: 'ProductCategoryTranslation';
  brc?: Maybe<Scalars['String']>;
  brc2?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idCateg?: Maybe<Scalars['Int']>;
  idMc: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
  metaDesc?: Maybe<Scalars['String']>;
  metaDescProd?: Maybe<Scalars['String']>;
  metaKeyw?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  prodLink?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subc?: Maybe<Scalars['String']>;
  subtext?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** A connection to a list of items. */
export type ProductConnection = {
  __typename?: 'ProductConnection';
  /** Information to aid in pagination */
  edges?: Maybe<Array<Maybe<ProductEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection */
export type ProductEdge = {
  __typename?: 'ProductEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Product>;
};

export type ProductInput = {
  /** The primary key for input is always id. */
  id?: InputMaybe<Scalars['Int']>;
  status: Scalars['String'];
};

export type ProductTranslation = Node & {
  __typename?: 'ProductTranslation';
  id: Scalars['ID'];
  idPl: Scalars['ID'];
  product?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  appSettings?: Maybe<AppSettingConnection>;
  blogCategories?: Maybe<BlogCategoryConnection>;
  blogPosts?: Maybe<BlogPostConnection>;
  checkPassword?: Maybe<Scalars['Boolean']>;
  groups?: Maybe<GroupConnection>;
  marts?: Maybe<MartConnection>;
  me?: Maybe<UserNode>;
  menus?: Maybe<MenuConnection>;
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  paymentMethods?: Maybe<PaymentMethodConnection>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  productCategories?: Maybe<ProductCategoryConnection>;
  products?: Maybe<ProductConnection>;
  users?: Maybe<UserNodeConnection>;
};


export type QueryAppSettingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};


export type QueryBlogCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryBlogPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  idBlog?: InputMaybe<Scalars['ID']>;
  lang?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCheckPasswordArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type QueryGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};


export type QueryMartsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMenusArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  extUrl_Icontains?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  idMenu?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  linkTo_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parent?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryNodeArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentMethodsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  idPay?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryProductCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  idCateg?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  idProd?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  email_Icontains?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type RefreshToken = {
  __typename?: 'RefreshToken';
  refreshToken?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
};

export type Register = {
  __typename?: 'Register';
  refreshToken?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
};

export type ResendActivationEmail = {
  __typename?: 'ResendActivationEmail';
  success?: Maybe<Scalars['Boolean']>;
};

export type SaveAppSetting = {
  __typename?: 'SaveAppSetting';
  object?: Maybe<AppSetting>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SaveBlogCategory = {
  __typename?: 'SaveBlogCategory';
  object?: Maybe<BlogCategory>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SaveBlogPost = {
  __typename?: 'SaveBlogPost';
  object?: Maybe<BlogPost>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SaveGroup = {
  __typename?: 'SaveGroup';
  object?: Maybe<Group>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SaveMart = {
  __typename?: 'SaveMart';
  object?: Maybe<Mart>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SaveMenu = {
  __typename?: 'SaveMenu';
  object?: Maybe<Menu>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SavePaymentMethod = {
  __typename?: 'SavePaymentMethod';
  object?: Maybe<PaymentMethod>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SaveProduct = {
  __typename?: 'SaveProduct';
  object?: Maybe<Product>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SaveProductCategory = {
  __typename?: 'SaveProductCategory';
  object?: Maybe<ProductCategory>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SaveUserNode = {
  __typename?: 'SaveUserNode';
  object?: Maybe<UserNode>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SendPasswordResetEmail = {
  __typename?: 'SendPasswordResetEmail';
  success?: Maybe<Scalars['Boolean']>;
};

export type SetPermissionsForGroup = {
  __typename?: 'SetPermissionsForGroup';
  success?: Maybe<Scalars['Boolean']>;
};

export type TokenAuth = {
  __typename?: 'TokenAuth';
  refreshToken?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<UserNode>;
};

export type UserInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  /** The primary key for input is always id. */
  id?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type UserNode = Node & {
  __typename?: 'UserNode';
  dateJoined?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  facebookLoginId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  googleLoginId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  isStaff?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};

/** A connection to a list of items. */
export type UserNodeConnection = {
  __typename?: 'UserNodeConnection';
  /** Information to aid in pagination */
  edges?: Maybe<Array<Maybe<UserNodeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection */
export type UserNodeEdge = {
  __typename?: 'UserNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<UserNode>;
};

export type VerifyAccount = {
  __typename?: 'VerifyAccount';
  success?: Maybe<Scalars['Boolean']>;
};

export type VerifyToken = {
  __typename?: 'VerifyToken';
  success?: Maybe<Scalars['Boolean']>;
};

export type PageInfoDetailsFragmentFragment = { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null };

export type UserDetailsFragmentFragment = { __typename?: 'UserNode', id: string, pk?: number | null, username?: string | null, email?: string | null, verified?: boolean | null, isStaff?: boolean | null, isActive?: boolean | null, dateJoined?: string | null, firstName?: string | null, lastName?: string | null, nickname?: string | null, name?: string | null, facebookLoginId?: string | null, googleLoginId?: string | null };

export type LoginFacebookUserMutationVariables = Exact<{
  facebookLoginId: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
}>;


export type LoginFacebookUserMutation = { __typename?: 'Mutation', loginFacebookUser?: { __typename?: 'LoginFacebookUser', success?: boolean | null, token?: string | null, refreshToken?: string | null, user?: { __typename?: 'UserNode', id: string, pk?: number | null, username?: string | null, email?: string | null, verified?: boolean | null, isStaff?: boolean | null, isActive?: boolean | null, dateJoined?: string | null, firstName?: string | null, lastName?: string | null, nickname?: string | null, name?: string | null, facebookLoginId?: string | null, googleLoginId?: string | null } | null } | null };

export type LoginGoogleUserMutationVariables = Exact<{
  googleLoginId: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
}>;


export type LoginGoogleUserMutation = { __typename?: 'Mutation', loginGoogleUser?: { __typename?: 'LoginGoogleUser', success?: boolean | null, token?: string | null, refreshToken?: string | null, user?: { __typename?: 'UserNode', id: string, pk?: number | null, username?: string | null, email?: string | null, verified?: boolean | null, isStaff?: boolean | null, isActive?: boolean | null, dateJoined?: string | null, firstName?: string | null, lastName?: string | null, nickname?: string | null, name?: string | null, facebookLoginId?: string | null, googleLoginId?: string | null } | null } | null };

export type LoginUserMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginUserMutation = { __typename?: 'Mutation', tokenAuth?: { __typename?: 'TokenAuth', success?: boolean | null, token?: string | null, refreshToken?: string | null, user?: { __typename?: 'UserNode', id: string, pk?: number | null, username?: string | null, email?: string | null, verified?: boolean | null, isStaff?: boolean | null, isActive?: boolean | null, dateJoined?: string | null, firstName?: string | null, lastName?: string | null, nickname?: string | null, name?: string | null, facebookLoginId?: string | null, googleLoginId?: string | null } | null } | null };

export type PasswordResetMutationVariables = Exact<{
  token: Scalars['String'];
  newPassword1: Scalars['String'];
  newPassword2: Scalars['String'];
}>;


export type PasswordResetMutation = { __typename?: 'Mutation', passwordReset?: { __typename?: 'PasswordReset', success?: boolean | null } | null };

export type RefreshUserTokenMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;


export type RefreshUserTokenMutation = { __typename?: 'Mutation', refreshToken?: { __typename?: 'RefreshToken', success?: boolean | null, token?: string | null, refreshToken?: string | null } | null };

export type RegisterUserMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type RegisterUserMutation = { __typename?: 'Mutation', register?: { __typename?: 'Register', success?: boolean | null, token?: string | null, refreshToken?: string | null } | null };

export type ResendActivationEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResendActivationEmailMutation = { __typename?: 'Mutation', resendActivationEmail?: { __typename?: 'ResendActivationEmail', success?: boolean | null } | null };

export type SendPasswordResetEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendPasswordResetEmailMutation = { __typename?: 'Mutation', sendPasswordResetEmail?: { __typename?: 'SendPasswordResetEmail', success?: boolean | null } | null };

export type SetPermissionsForGroupMutationVariables = Exact<{
  groupId: Scalars['Int'];
  permissionCodenames?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type SetPermissionsForGroupMutation = { __typename?: 'Mutation', setPermissionsForGroup?: { __typename?: 'SetPermissionsForGroup', success?: boolean | null } | null };

export type VerifyAccountMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyAccountMutation = { __typename?: 'Mutation', verifyAccount?: { __typename?: 'VerifyAccount', success?: boolean | null } | null };

export type VerifyUserTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyUserTokenMutation = { __typename?: 'Mutation', verifyToken?: { __typename?: 'VerifyToken', success?: boolean | null } | null };

export type CheckPasswordQueryVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type CheckPasswordQuery = { __typename?: 'Query', checkPassword?: boolean | null };

export type ListPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListPermissionsQuery = { __typename?: 'Query', permissions?: Array<{ __typename?: 'Permission', codename?: string | null, name?: string | null } | null> | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UserNode', id: string, pk?: number | null, username?: string | null, email?: string | null, verified?: boolean | null, isStaff?: boolean | null, isActive?: boolean | null, dateJoined?: string | null, firstName?: string | null, lastName?: string | null, nickname?: string | null, name?: string | null, facebookLoginId?: string | null, googleLoginId?: string | null } | null };

export const PageInfoDetailsFragmentFragmentDoc = gql`
    fragment PageInfoDetailsFragment on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
export const UserDetailsFragmentFragmentDoc = gql`
    fragment UserDetailsFragment on UserNode {
  id
  pk
  username
  email
  verified
  isStaff
  isActive
  dateJoined
  firstName
  lastName
  nickname
  name
  facebookLoginId
  googleLoginId
}
    `;
export const LoginFacebookUserDocument = gql`
    mutation LoginFacebookUser($facebookLoginId: String!, $email: String) {
  loginFacebookUser(facebookLoginId: $facebookLoginId, email: $email) {
    success
    token
    refreshToken
    user {
      ...UserDetailsFragment
    }
  }
}
    ${UserDetailsFragmentFragmentDoc}`;
export type LoginFacebookUserMutationFn = Apollo.MutationFunction<LoginFacebookUserMutation, LoginFacebookUserMutationVariables>;

/**
 * __useLoginFacebookUserMutation__
 *
 * To run a mutation, you first call `useLoginFacebookUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginFacebookUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginFacebookUserMutation, { data, loading, error }] = useLoginFacebookUserMutation({
 *   variables: {
 *      facebookLoginId: // value for 'facebookLoginId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useLoginFacebookUserMutation(baseOptions?: Apollo.MutationHookOptions<LoginFacebookUserMutation, LoginFacebookUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginFacebookUserMutation, LoginFacebookUserMutationVariables>(LoginFacebookUserDocument, options);
      }
export type LoginFacebookUserMutationHookResult = ReturnType<typeof useLoginFacebookUserMutation>;
export type LoginFacebookUserMutationResult = Apollo.MutationResult<LoginFacebookUserMutation>;
export type LoginFacebookUserMutationOptions = Apollo.BaseMutationOptions<LoginFacebookUserMutation, LoginFacebookUserMutationVariables>;
export const LoginGoogleUserDocument = gql`
    mutation LoginGoogleUser($googleLoginId: String!, $email: String) {
  loginGoogleUser(googleLoginId: $googleLoginId, email: $email) {
    success
    token
    refreshToken
    user {
      ...UserDetailsFragment
    }
  }
}
    ${UserDetailsFragmentFragmentDoc}`;
export type LoginGoogleUserMutationFn = Apollo.MutationFunction<LoginGoogleUserMutation, LoginGoogleUserMutationVariables>;

/**
 * __useLoginGoogleUserMutation__
 *
 * To run a mutation, you first call `useLoginGoogleUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginGoogleUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginGoogleUserMutation, { data, loading, error }] = useLoginGoogleUserMutation({
 *   variables: {
 *      googleLoginId: // value for 'googleLoginId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useLoginGoogleUserMutation(baseOptions?: Apollo.MutationHookOptions<LoginGoogleUserMutation, LoginGoogleUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginGoogleUserMutation, LoginGoogleUserMutationVariables>(LoginGoogleUserDocument, options);
      }
export type LoginGoogleUserMutationHookResult = ReturnType<typeof useLoginGoogleUserMutation>;
export type LoginGoogleUserMutationResult = Apollo.MutationResult<LoginGoogleUserMutation>;
export type LoginGoogleUserMutationOptions = Apollo.BaseMutationOptions<LoginGoogleUserMutation, LoginGoogleUserMutationVariables>;
export const LoginUserDocument = gql`
    mutation LoginUser($email: String!, $password: String!) {
  tokenAuth(email: $email, password: $password) {
    success
    token
    refreshToken
    user {
      ...UserDetailsFragment
    }
  }
}
    ${UserDetailsFragmentFragmentDoc}`;
export type LoginUserMutationFn = Apollo.MutationFunction<LoginUserMutation, LoginUserMutationVariables>;

/**
 * __useLoginUserMutation__
 *
 * To run a mutation, you first call `useLoginUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUserMutation, { data, loading, error }] = useLoginUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginUserMutation(baseOptions?: Apollo.MutationHookOptions<LoginUserMutation, LoginUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginUserMutation, LoginUserMutationVariables>(LoginUserDocument, options);
      }
export type LoginUserMutationHookResult = ReturnType<typeof useLoginUserMutation>;
export type LoginUserMutationResult = Apollo.MutationResult<LoginUserMutation>;
export type LoginUserMutationOptions = Apollo.BaseMutationOptions<LoginUserMutation, LoginUserMutationVariables>;
export const PasswordResetDocument = gql`
    mutation PasswordReset($token: String!, $newPassword1: String!, $newPassword2: String!) {
  passwordReset(
    token: $token
    newPassword1: $newPassword1
    newPassword2: $newPassword2
  ) {
    success
  }
}
    `;
export type PasswordResetMutationFn = Apollo.MutationFunction<PasswordResetMutation, PasswordResetMutationVariables>;

/**
 * __usePasswordResetMutation__
 *
 * To run a mutation, you first call `usePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetMutation, { data, loading, error }] = usePasswordResetMutation({
 *   variables: {
 *      token: // value for 'token'
 *      newPassword1: // value for 'newPassword1'
 *      newPassword2: // value for 'newPassword2'
 *   },
 * });
 */
export function usePasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<PasswordResetMutation, PasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasswordResetMutation, PasswordResetMutationVariables>(PasswordResetDocument, options);
      }
export type PasswordResetMutationHookResult = ReturnType<typeof usePasswordResetMutation>;
export type PasswordResetMutationResult = Apollo.MutationResult<PasswordResetMutation>;
export type PasswordResetMutationOptions = Apollo.BaseMutationOptions<PasswordResetMutation, PasswordResetMutationVariables>;
export const RefreshUserTokenDocument = gql`
    mutation RefreshUserToken($refreshToken: String!) {
  refreshToken(refreshToken: $refreshToken) {
    success
    token
    refreshToken
  }
}
    `;
export type RefreshUserTokenMutationFn = Apollo.MutationFunction<RefreshUserTokenMutation, RefreshUserTokenMutationVariables>;

/**
 * __useRefreshUserTokenMutation__
 *
 * To run a mutation, you first call `useRefreshUserTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshUserTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshUserTokenMutation, { data, loading, error }] = useRefreshUserTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshUserTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshUserTokenMutation, RefreshUserTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshUserTokenMutation, RefreshUserTokenMutationVariables>(RefreshUserTokenDocument, options);
      }
export type RefreshUserTokenMutationHookResult = ReturnType<typeof useRefreshUserTokenMutation>;
export type RefreshUserTokenMutationResult = Apollo.MutationResult<RefreshUserTokenMutation>;
export type RefreshUserTokenMutationOptions = Apollo.BaseMutationOptions<RefreshUserTokenMutation, RefreshUserTokenMutationVariables>;
export const RegisterUserDocument = gql`
    mutation RegisterUser($email: String!, $password: String!) {
  register(
    email: $email
    username: $email
    password1: $password
    password2: $password
  ) {
    success
    token
    refreshToken
  }
}
    `;
export type RegisterUserMutationFn = Apollo.MutationFunction<RegisterUserMutation, RegisterUserMutationVariables>;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useRegisterUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserMutation, RegisterUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserMutation, RegisterUserMutationVariables>(RegisterUserDocument, options);
      }
export type RegisterUserMutationHookResult = ReturnType<typeof useRegisterUserMutation>;
export type RegisterUserMutationResult = Apollo.MutationResult<RegisterUserMutation>;
export type RegisterUserMutationOptions = Apollo.BaseMutationOptions<RegisterUserMutation, RegisterUserMutationVariables>;
export const ResendActivationEmailDocument = gql`
    mutation ResendActivationEmail($email: String!) {
  resendActivationEmail(email: $email) {
    success
  }
}
    `;
export type ResendActivationEmailMutationFn = Apollo.MutationFunction<ResendActivationEmailMutation, ResendActivationEmailMutationVariables>;

/**
 * __useResendActivationEmailMutation__
 *
 * To run a mutation, you first call `useResendActivationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendActivationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendActivationEmailMutation, { data, loading, error }] = useResendActivationEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendActivationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendActivationEmailMutation, ResendActivationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendActivationEmailMutation, ResendActivationEmailMutationVariables>(ResendActivationEmailDocument, options);
      }
export type ResendActivationEmailMutationHookResult = ReturnType<typeof useResendActivationEmailMutation>;
export type ResendActivationEmailMutationResult = Apollo.MutationResult<ResendActivationEmailMutation>;
export type ResendActivationEmailMutationOptions = Apollo.BaseMutationOptions<ResendActivationEmailMutation, ResendActivationEmailMutationVariables>;
export const SendPasswordResetEmailDocument = gql`
    mutation SendPasswordResetEmail($email: String!) {
  sendPasswordResetEmail(email: $email) {
    success
  }
}
    `;
export type SendPasswordResetEmailMutationFn = Apollo.MutationFunction<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;

/**
 * __useSendPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailMutation, { data, loading, error }] = useSendPasswordResetEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendPasswordResetEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>(SendPasswordResetEmailDocument, options);
      }
export type SendPasswordResetEmailMutationHookResult = ReturnType<typeof useSendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationResult = Apollo.MutationResult<SendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;
export const SetPermissionsForGroupDocument = gql`
    mutation SetPermissionsForGroup($groupId: Int!, $permissionCodenames: [String]) {
  setPermissionsForGroup(
    groupId: $groupId
    permissionCodenames: $permissionCodenames
  ) {
    success
  }
}
    `;
export type SetPermissionsForGroupMutationFn = Apollo.MutationFunction<SetPermissionsForGroupMutation, SetPermissionsForGroupMutationVariables>;

/**
 * __useSetPermissionsForGroupMutation__
 *
 * To run a mutation, you first call `useSetPermissionsForGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPermissionsForGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPermissionsForGroupMutation, { data, loading, error }] = useSetPermissionsForGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      permissionCodenames: // value for 'permissionCodenames'
 *   },
 * });
 */
export function useSetPermissionsForGroupMutation(baseOptions?: Apollo.MutationHookOptions<SetPermissionsForGroupMutation, SetPermissionsForGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPermissionsForGroupMutation, SetPermissionsForGroupMutationVariables>(SetPermissionsForGroupDocument, options);
      }
export type SetPermissionsForGroupMutationHookResult = ReturnType<typeof useSetPermissionsForGroupMutation>;
export type SetPermissionsForGroupMutationResult = Apollo.MutationResult<SetPermissionsForGroupMutation>;
export type SetPermissionsForGroupMutationOptions = Apollo.BaseMutationOptions<SetPermissionsForGroupMutation, SetPermissionsForGroupMutationVariables>;
export const VerifyAccountDocument = gql`
    mutation VerifyAccount($token: String!) {
  verifyAccount(token: $token) {
    success
  }
}
    `;
export type VerifyAccountMutationFn = Apollo.MutationFunction<VerifyAccountMutation, VerifyAccountMutationVariables>;

/**
 * __useVerifyAccountMutation__
 *
 * To run a mutation, you first call `useVerifyAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAccountMutation, { data, loading, error }] = useVerifyAccountMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyAccountMutation(baseOptions?: Apollo.MutationHookOptions<VerifyAccountMutation, VerifyAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyAccountMutation, VerifyAccountMutationVariables>(VerifyAccountDocument, options);
      }
export type VerifyAccountMutationHookResult = ReturnType<typeof useVerifyAccountMutation>;
export type VerifyAccountMutationResult = Apollo.MutationResult<VerifyAccountMutation>;
export type VerifyAccountMutationOptions = Apollo.BaseMutationOptions<VerifyAccountMutation, VerifyAccountMutationVariables>;
export const VerifyUserTokenDocument = gql`
    mutation VerifyUserToken($token: String!) {
  verifyToken(token: $token) {
    success
  }
}
    `;
export type VerifyUserTokenMutationFn = Apollo.MutationFunction<VerifyUserTokenMutation, VerifyUserTokenMutationVariables>;

/**
 * __useVerifyUserTokenMutation__
 *
 * To run a mutation, you first call `useVerifyUserTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyUserTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyUserTokenMutation, { data, loading, error }] = useVerifyUserTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyUserTokenMutation(baseOptions?: Apollo.MutationHookOptions<VerifyUserTokenMutation, VerifyUserTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyUserTokenMutation, VerifyUserTokenMutationVariables>(VerifyUserTokenDocument, options);
      }
export type VerifyUserTokenMutationHookResult = ReturnType<typeof useVerifyUserTokenMutation>;
export type VerifyUserTokenMutationResult = Apollo.MutationResult<VerifyUserTokenMutation>;
export type VerifyUserTokenMutationOptions = Apollo.BaseMutationOptions<VerifyUserTokenMutation, VerifyUserTokenMutationVariables>;
export const CheckPasswordDocument = gql`
    query CheckPassword($email: String!, $password: String!) {
  checkPassword(email: $email, password: $password)
}
    `;

/**
 * __useCheckPasswordQuery__
 *
 * To run a query within a React component, call `useCheckPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckPasswordQuery({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCheckPasswordQuery(baseOptions: Apollo.QueryHookOptions<CheckPasswordQuery, CheckPasswordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckPasswordQuery, CheckPasswordQueryVariables>(CheckPasswordDocument, options);
      }
export function useCheckPasswordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckPasswordQuery, CheckPasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckPasswordQuery, CheckPasswordQueryVariables>(CheckPasswordDocument, options);
        }
export type CheckPasswordQueryHookResult = ReturnType<typeof useCheckPasswordQuery>;
export type CheckPasswordLazyQueryHookResult = ReturnType<typeof useCheckPasswordLazyQuery>;
export type CheckPasswordQueryResult = Apollo.QueryResult<CheckPasswordQuery, CheckPasswordQueryVariables>;
export const ListPermissionsDocument = gql`
    query ListPermissions {
  permissions {
    codename
    name
  }
}
    `;

/**
 * __useListPermissionsQuery__
 *
 * To run a query within a React component, call `useListPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<ListPermissionsQuery, ListPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPermissionsQuery, ListPermissionsQueryVariables>(ListPermissionsDocument, options);
      }
export function useListPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPermissionsQuery, ListPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPermissionsQuery, ListPermissionsQueryVariables>(ListPermissionsDocument, options);
        }
export type ListPermissionsQueryHookResult = ReturnType<typeof useListPermissionsQuery>;
export type ListPermissionsLazyQueryHookResult = ReturnType<typeof useListPermissionsLazyQuery>;
export type ListPermissionsQueryResult = Apollo.QueryResult<ListPermissionsQuery, ListPermissionsQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...UserDetailsFragment
  }
}
    ${UserDetailsFragmentFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export type AppSettingKeySpecifier = ('id' | 'isPublic' | 'name' | 'value' | AppSettingKeySpecifier)[];
export type AppSettingFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppSettingConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | AppSettingConnectionKeySpecifier)[];
export type AppSettingConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppSettingEdgeKeySpecifier = ('cursor' | 'node' | AppSettingEdgeKeySpecifier)[];
export type AppSettingEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BlogCategoryKeySpecifier = ('id' | 'lang' | 'title' | BlogCategoryKeySpecifier)[];
export type BlogCategoryFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lang?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BlogCategoryConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | BlogCategoryConnectionKeySpecifier)[];
export type BlogCategoryConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BlogCategoryEdgeKeySpecifier = ('cursor' | 'node' | BlogCategoryEdgeKeySpecifier)[];
export type BlogCategoryEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BlogPostKeySpecifier = ('body' | 'category' | 'datum' | 'descript' | 'id' | 'idBlog' | 'idCateg' | 'image' | 'lang' | 'status' | 'tags' | 'title' | BlogPostKeySpecifier)[];
export type BlogPostFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	datum?: FieldPolicy<any> | FieldReadFunction<any>,
	descript?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	idBlog?: FieldPolicy<any> | FieldReadFunction<any>,
	idCateg?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	lang?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BlogPostConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | BlogPostConnectionKeySpecifier)[];
export type BlogPostConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BlogPostEdgeKeySpecifier = ('cursor' | 'node' | BlogPostEdgeKeySpecifier)[];
export type BlogPostEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteAppSettingKeySpecifier = ('success' | DeleteAppSettingKeySpecifier)[];
export type DeleteAppSettingFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteBlogCategoryKeySpecifier = ('success' | DeleteBlogCategoryKeySpecifier)[];
export type DeleteBlogCategoryFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteBlogPostKeySpecifier = ('success' | DeleteBlogPostKeySpecifier)[];
export type DeleteBlogPostFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteGroupKeySpecifier = ('success' | DeleteGroupKeySpecifier)[];
export type DeleteGroupFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteMartKeySpecifier = ('success' | DeleteMartKeySpecifier)[];
export type DeleteMartFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteMenuKeySpecifier = ('success' | DeleteMenuKeySpecifier)[];
export type DeleteMenuFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeletePaymentMethodKeySpecifier = ('success' | DeletePaymentMethodKeySpecifier)[];
export type DeletePaymentMethodFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteProductKeySpecifier = ('success' | DeleteProductKeySpecifier)[];
export type DeleteProductFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteProductCategoryKeySpecifier = ('success' | DeleteProductCategoryKeySpecifier)[];
export type DeleteProductCategoryFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteUserNodeKeySpecifier = ('success' | DeleteUserNodeKeySpecifier)[];
export type DeleteUserNodeFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupKeySpecifier = ('id' | 'name' | 'permissions' | GroupKeySpecifier)[];
export type GroupFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | GroupConnectionKeySpecifier)[];
export type GroupConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupEdgeKeySpecifier = ('cursor' | 'node' | GroupEdgeKeySpecifier)[];
export type GroupEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LoginFacebookUserKeySpecifier = ('refreshToken' | 'success' | 'token' | 'user' | LoginFacebookUserKeySpecifier)[];
export type LoginFacebookUserFieldPolicy = {
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LoginGoogleUserKeySpecifier = ('refreshToken' | 'success' | 'token' | 'user' | LoginGoogleUserKeySpecifier)[];
export type LoginGoogleUserFieldPolicy = {
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MartKeySpecifier = ('awb' | 'bookName' | 'bookmark' | 'chartTax' | 'cod' | 'comment' | 'curier' | 'dateOrd' | 'factCegnev' | 'factCim' | 'factCodfisc' | 'factEmail' | 'factFullname' | 'factIsceg' | 'factMegye' | 'factNrord' | 'factPostakod' | 'factTelefon' | 'factVaros' | 'id' | 'idUser' | 'kupon' | 'kupond' | 'nrOrd' | 'ok' | 'paymentMethod' | 'ramb1' | 'ramb2' | 'status' | 'statuschange' | 'szk' | 'tipus' | 'trans1' | 'trans2' | 'trans3' | 'transCim' | 'transFullname' | 'transMegye' | 'transPostakod' | 'transTelefon' | 'transVaros' | 'ufiz' | 'uzlet' | MartKeySpecifier)[];
export type MartFieldPolicy = {
	awb?: FieldPolicy<any> | FieldReadFunction<any>,
	bookName?: FieldPolicy<any> | FieldReadFunction<any>,
	bookmark?: FieldPolicy<any> | FieldReadFunction<any>,
	chartTax?: FieldPolicy<any> | FieldReadFunction<any>,
	cod?: FieldPolicy<any> | FieldReadFunction<any>,
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	curier?: FieldPolicy<any> | FieldReadFunction<any>,
	dateOrd?: FieldPolicy<any> | FieldReadFunction<any>,
	factCegnev?: FieldPolicy<any> | FieldReadFunction<any>,
	factCim?: FieldPolicy<any> | FieldReadFunction<any>,
	factCodfisc?: FieldPolicy<any> | FieldReadFunction<any>,
	factEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	factFullname?: FieldPolicy<any> | FieldReadFunction<any>,
	factIsceg?: FieldPolicy<any> | FieldReadFunction<any>,
	factMegye?: FieldPolicy<any> | FieldReadFunction<any>,
	factNrord?: FieldPolicy<any> | FieldReadFunction<any>,
	factPostakod?: FieldPolicy<any> | FieldReadFunction<any>,
	factTelefon?: FieldPolicy<any> | FieldReadFunction<any>,
	factVaros?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	idUser?: FieldPolicy<any> | FieldReadFunction<any>,
	kupon?: FieldPolicy<any> | FieldReadFunction<any>,
	kupond?: FieldPolicy<any> | FieldReadFunction<any>,
	nrOrd?: FieldPolicy<any> | FieldReadFunction<any>,
	ok?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	ramb1?: FieldPolicy<any> | FieldReadFunction<any>,
	ramb2?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	statuschange?: FieldPolicy<any> | FieldReadFunction<any>,
	szk?: FieldPolicy<any> | FieldReadFunction<any>,
	tipus?: FieldPolicy<any> | FieldReadFunction<any>,
	trans1?: FieldPolicy<any> | FieldReadFunction<any>,
	trans2?: FieldPolicy<any> | FieldReadFunction<any>,
	trans3?: FieldPolicy<any> | FieldReadFunction<any>,
	transCim?: FieldPolicy<any> | FieldReadFunction<any>,
	transFullname?: FieldPolicy<any> | FieldReadFunction<any>,
	transMegye?: FieldPolicy<any> | FieldReadFunction<any>,
	transPostakod?: FieldPolicy<any> | FieldReadFunction<any>,
	transTelefon?: FieldPolicy<any> | FieldReadFunction<any>,
	transVaros?: FieldPolicy<any> | FieldReadFunction<any>,
	ufiz?: FieldPolicy<any> | FieldReadFunction<any>,
	uzlet?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MartConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | MartConnectionKeySpecifier)[];
export type MartConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MartEdgeKeySpecifier = ('cursor' | 'node' | MartEdgeKeySpecifier)[];
export type MartEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuKeySpecifier = ('extUrl' | 'id' | 'idMenu' | 'itemId' | 'linkTo' | 'location' | 'ordered' | 'parent' | 'status' | MenuKeySpecifier)[];
export type MenuFieldPolicy = {
	extUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	idMenu?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	linkTo?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	ordered?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | MenuConnectionKeySpecifier)[];
export type MenuConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuEdgeKeySpecifier = ('cursor' | 'node' | MenuEdgeKeySpecifier)[];
export type MenuEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('deleteAppSetting' | 'deleteBlogCategory' | 'deleteBlogPost' | 'deleteGroup' | 'deleteMart' | 'deleteMenu' | 'deletePaymentMethod' | 'deleteProduct' | 'deleteProductCategory' | 'deleteUser' | 'loginFacebookUser' | 'loginGoogleUser' | 'passwordReset' | 'refreshToken' | 'register' | 'resendActivationEmail' | 'saveAppSetting' | 'saveBlogCategory' | 'saveBlogPost' | 'saveGroup' | 'saveMart' | 'saveMenu' | 'savePaymentMethod' | 'saveProduct' | 'saveProductCategory' | 'saveUser' | 'sendPasswordResetEmail' | 'setPermissionsForGroup' | 'tokenAuth' | 'trackWithFacebookConversionsApi' | 'verifyAccount' | 'verifyToken' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	deleteAppSetting?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBlogCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBlogPost?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMart?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMenu?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePaymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteProductCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUser?: FieldPolicy<any> | FieldReadFunction<any>,
	loginFacebookUser?: FieldPolicy<any> | FieldReadFunction<any>,
	loginGoogleUser?: FieldPolicy<any> | FieldReadFunction<any>,
	passwordReset?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	register?: FieldPolicy<any> | FieldReadFunction<any>,
	resendActivationEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	saveAppSetting?: FieldPolicy<any> | FieldReadFunction<any>,
	saveBlogCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	saveBlogPost?: FieldPolicy<any> | FieldReadFunction<any>,
	saveGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	saveMart?: FieldPolicy<any> | FieldReadFunction<any>,
	saveMenu?: FieldPolicy<any> | FieldReadFunction<any>,
	savePaymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	saveProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	saveProductCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	saveUser?: FieldPolicy<any> | FieldReadFunction<any>,
	sendPasswordResetEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	setPermissionsForGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	tokenAuth?: FieldPolicy<any> | FieldReadFunction<any>,
	trackWithFacebookConversionsApi?: FieldPolicy<any> | FieldReadFunction<any>,
	verifyAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	verifyToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NodeKeySpecifier = ('id' | NodeKeySpecifier)[];
export type NodeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | PageInfoKeySpecifier)[];
export type PageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PasswordResetKeySpecifier = ('success' | PasswordResetKeySpecifier)[];
export type PasswordResetFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentMethodKeySpecifier = ('id' | 'idPay' | 'idTrans' | 'orderNo' | 'p1' | 'paymentType' | 'price' | 'status' | 'translation' | PaymentMethodKeySpecifier)[];
export type PaymentMethodFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	idPay?: FieldPolicy<any> | FieldReadFunction<any>,
	idTrans?: FieldPolicy<any> | FieldReadFunction<any>,
	orderNo?: FieldPolicy<any> | FieldReadFunction<any>,
	p1?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentType?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentMethodConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | PaymentMethodConnectionKeySpecifier)[];
export type PaymentMethodConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentMethodEdgeKeySpecifier = ('cursor' | 'node' | PaymentMethodEdgeKeySpecifier)[];
export type PaymentMethodEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentMethodTranslationKeySpecifier = ('descript' | 'id' | 'idPay' | 'idPl' | 'lang' | 'paymentMethod' | 'status' | 'title' | PaymentMethodTranslationKeySpecifier)[];
export type PaymentMethodTranslationFieldPolicy = {
	descript?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	idPay?: FieldPolicy<any> | FieldReadFunction<any>,
	idPl?: FieldPolicy<any> | FieldReadFunction<any>,
	lang?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PermissionKeySpecifier = ('codename' | 'id' | 'name' | PermissionKeySpecifier)[];
export type PermissionFieldPolicy = {
	codename?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductKeySpecifier = ('brandName' | 'colorName' | 'discEnd' | 'discPer' | 'discStart' | 'discStatus' | 'discVal' | 'discopt' | 'fee' | 'gyarto' | 'id' | 'idProd' | 'isindex' | 'kedve' | 'kifut' | 'kod' | 'kod2' | 'lastmod' | 'mainCategory' | 'model' | 'ok' | 'ordered' | 'parent' | 'parentProduct' | 'pe' | 'prodPrice' | 'prodPrice0' | 'prodPrice2' | 'promo' | 'raktar' | 'raktarAct' | 'raktarAct2' | 'raktarDisc' | 'raktarFp' | 'raktarMod' | 'rendelheto' | 'sing' | 'some' | 'specBuc' | 'specPrice' | 'status' | 'suly' | 'tablink' | 'trans' | 'translation' | 'uj' | 'upimage' | 'uptime' | 'video' | 'vidreplace' | 'views' | ProductKeySpecifier)[];
export type ProductFieldPolicy = {
	brandName?: FieldPolicy<any> | FieldReadFunction<any>,
	colorName?: FieldPolicy<any> | FieldReadFunction<any>,
	discEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	discPer?: FieldPolicy<any> | FieldReadFunction<any>,
	discStart?: FieldPolicy<any> | FieldReadFunction<any>,
	discStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	discVal?: FieldPolicy<any> | FieldReadFunction<any>,
	discopt?: FieldPolicy<any> | FieldReadFunction<any>,
	fee?: FieldPolicy<any> | FieldReadFunction<any>,
	gyarto?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	idProd?: FieldPolicy<any> | FieldReadFunction<any>,
	isindex?: FieldPolicy<any> | FieldReadFunction<any>,
	kedve?: FieldPolicy<any> | FieldReadFunction<any>,
	kifut?: FieldPolicy<any> | FieldReadFunction<any>,
	kod?: FieldPolicy<any> | FieldReadFunction<any>,
	kod2?: FieldPolicy<any> | FieldReadFunction<any>,
	lastmod?: FieldPolicy<any> | FieldReadFunction<any>,
	mainCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	ok?: FieldPolicy<any> | FieldReadFunction<any>,
	ordered?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>,
	parentProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	pe?: FieldPolicy<any> | FieldReadFunction<any>,
	prodPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	prodPrice0?: FieldPolicy<any> | FieldReadFunction<any>,
	prodPrice2?: FieldPolicy<any> | FieldReadFunction<any>,
	promo?: FieldPolicy<any> | FieldReadFunction<any>,
	raktar?: FieldPolicy<any> | FieldReadFunction<any>,
	raktarAct?: FieldPolicy<any> | FieldReadFunction<any>,
	raktarAct2?: FieldPolicy<any> | FieldReadFunction<any>,
	raktarDisc?: FieldPolicy<any> | FieldReadFunction<any>,
	raktarFp?: FieldPolicy<any> | FieldReadFunction<any>,
	raktarMod?: FieldPolicy<any> | FieldReadFunction<any>,
	rendelheto?: FieldPolicy<any> | FieldReadFunction<any>,
	sing?: FieldPolicy<any> | FieldReadFunction<any>,
	some?: FieldPolicy<any> | FieldReadFunction<any>,
	specBuc?: FieldPolicy<any> | FieldReadFunction<any>,
	specPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	suly?: FieldPolicy<any> | FieldReadFunction<any>,
	tablink?: FieldPolicy<any> | FieldReadFunction<any>,
	trans?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	uj?: FieldPolicy<any> | FieldReadFunction<any>,
	upimage?: FieldPolicy<any> | FieldReadFunction<any>,
	uptime?: FieldPolicy<any> | FieldReadFunction<any>,
	video?: FieldPolicy<any> | FieldReadFunction<any>,
	vidreplace?: FieldPolicy<any> | FieldReadFunction<any>,
	views?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCategoryKeySpecifier = ('googleid' | 'hs' | 'id' | 'idCateg' | 'ikon' | 'image' | 'isindex' | 'kiem' | 'kval' | 'lastmod' | 'linkTo' | 'location' | 'location2' | 'maxp' | 'ordered' | 'parent' | 'parentCategory' | 'sectitle' | 'status' | 'trans' | 'translation' | ProductCategoryKeySpecifier)[];
export type ProductCategoryFieldPolicy = {
	googleid?: FieldPolicy<any> | FieldReadFunction<any>,
	hs?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	idCateg?: FieldPolicy<any> | FieldReadFunction<any>,
	ikon?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	isindex?: FieldPolicy<any> | FieldReadFunction<any>,
	kiem?: FieldPolicy<any> | FieldReadFunction<any>,
	kval?: FieldPolicy<any> | FieldReadFunction<any>,
	lastmod?: FieldPolicy<any> | FieldReadFunction<any>,
	linkTo?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	location2?: FieldPolicy<any> | FieldReadFunction<any>,
	maxp?: FieldPolicy<any> | FieldReadFunction<any>,
	ordered?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>,
	parentCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	sectitle?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	trans?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCategoryConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | ProductCategoryConnectionKeySpecifier)[];
export type ProductCategoryConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCategoryEdgeKeySpecifier = ('cursor' | 'node' | ProductCategoryEdgeKeySpecifier)[];
export type ProductCategoryEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCategoryTranslationKeySpecifier = ('brc' | 'brc2' | 'id' | 'idCateg' | 'idMc' | 'image' | 'imageUrl' | 'lang' | 'metaDesc' | 'metaDescProd' | 'metaKeyw' | 'metaTitle' | 'prodLink' | 'productCategory' | 'status' | 'subc' | 'subtext' | 'title' | ProductCategoryTranslationKeySpecifier)[];
export type ProductCategoryTranslationFieldPolicy = {
	brc?: FieldPolicy<any> | FieldReadFunction<any>,
	brc2?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	idCateg?: FieldPolicy<any> | FieldReadFunction<any>,
	idMc?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	lang?: FieldPolicy<any> | FieldReadFunction<any>,
	metaDesc?: FieldPolicy<any> | FieldReadFunction<any>,
	metaDescProd?: FieldPolicy<any> | FieldReadFunction<any>,
	metaKeyw?: FieldPolicy<any> | FieldReadFunction<any>,
	metaTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	prodLink?: FieldPolicy<any> | FieldReadFunction<any>,
	productCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	subc?: FieldPolicy<any> | FieldReadFunction<any>,
	subtext?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | ProductConnectionKeySpecifier)[];
export type ProductConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductEdgeKeySpecifier = ('cursor' | 'node' | ProductEdgeKeySpecifier)[];
export type ProductEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductTranslationKeySpecifier = ('id' | 'idPl' | 'product' | ProductTranslationKeySpecifier)[];
export type ProductTranslationFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	idPl?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('appSettings' | 'blogCategories' | 'blogPosts' | 'checkPassword' | 'groups' | 'marts' | 'me' | 'menus' | 'node' | 'paymentMethods' | 'permissions' | 'productCategories' | 'products' | 'users' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	appSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	blogCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	blogPosts?: FieldPolicy<any> | FieldReadFunction<any>,
	checkPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	marts?: FieldPolicy<any> | FieldReadFunction<any>,
	me?: FieldPolicy<any> | FieldReadFunction<any>,
	menus?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethods?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	productCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefreshTokenKeySpecifier = ('refreshToken' | 'success' | 'token' | RefreshTokenKeySpecifier)[];
export type RefreshTokenFieldPolicy = {
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegisterKeySpecifier = ('refreshToken' | 'success' | 'token' | RegisterKeySpecifier)[];
export type RegisterFieldPolicy = {
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ResendActivationEmailKeySpecifier = ('success' | ResendActivationEmailKeySpecifier)[];
export type ResendActivationEmailFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaveAppSettingKeySpecifier = ('object' | 'success' | SaveAppSettingKeySpecifier)[];
export type SaveAppSettingFieldPolicy = {
	object?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaveBlogCategoryKeySpecifier = ('object' | 'success' | SaveBlogCategoryKeySpecifier)[];
export type SaveBlogCategoryFieldPolicy = {
	object?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaveBlogPostKeySpecifier = ('object' | 'success' | SaveBlogPostKeySpecifier)[];
export type SaveBlogPostFieldPolicy = {
	object?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaveGroupKeySpecifier = ('object' | 'success' | SaveGroupKeySpecifier)[];
export type SaveGroupFieldPolicy = {
	object?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaveMartKeySpecifier = ('object' | 'success' | SaveMartKeySpecifier)[];
export type SaveMartFieldPolicy = {
	object?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaveMenuKeySpecifier = ('object' | 'success' | SaveMenuKeySpecifier)[];
export type SaveMenuFieldPolicy = {
	object?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SavePaymentMethodKeySpecifier = ('object' | 'success' | SavePaymentMethodKeySpecifier)[];
export type SavePaymentMethodFieldPolicy = {
	object?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaveProductKeySpecifier = ('object' | 'success' | SaveProductKeySpecifier)[];
export type SaveProductFieldPolicy = {
	object?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaveProductCategoryKeySpecifier = ('object' | 'success' | SaveProductCategoryKeySpecifier)[];
export type SaveProductCategoryFieldPolicy = {
	object?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaveUserNodeKeySpecifier = ('object' | 'success' | SaveUserNodeKeySpecifier)[];
export type SaveUserNodeFieldPolicy = {
	object?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendPasswordResetEmailKeySpecifier = ('success' | SendPasswordResetEmailKeySpecifier)[];
export type SendPasswordResetEmailFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SetPermissionsForGroupKeySpecifier = ('success' | SetPermissionsForGroupKeySpecifier)[];
export type SetPermissionsForGroupFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TokenAuthKeySpecifier = ('refreshToken' | 'success' | 'token' | 'user' | TokenAuthKeySpecifier)[];
export type TokenAuthFieldPolicy = {
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserNodeKeySpecifier = ('dateJoined' | 'email' | 'facebookLoginId' | 'firstName' | 'googleLoginId' | 'id' | 'isActive' | 'isStaff' | 'lastLogin' | 'lastName' | 'name' | 'nickname' | 'pk' | 'username' | 'verified' | UserNodeKeySpecifier)[];
export type UserNodeFieldPolicy = {
	dateJoined?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	facebookLoginId?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	googleLoginId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isStaff?: FieldPolicy<any> | FieldReadFunction<any>,
	lastLogin?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nickname?: FieldPolicy<any> | FieldReadFunction<any>,
	pk?: FieldPolicy<any> | FieldReadFunction<any>,
	username?: FieldPolicy<any> | FieldReadFunction<any>,
	verified?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserNodeConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | UserNodeConnectionKeySpecifier)[];
export type UserNodeConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserNodeEdgeKeySpecifier = ('cursor' | 'node' | UserNodeEdgeKeySpecifier)[];
export type UserNodeEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VerifyAccountKeySpecifier = ('success' | VerifyAccountKeySpecifier)[];
export type VerifyAccountFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VerifyTokenKeySpecifier = ('success' | VerifyTokenKeySpecifier)[];
export type VerifyTokenFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	AppSetting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppSettingKeySpecifier | (() => undefined | AppSettingKeySpecifier),
		fields?: AppSettingFieldPolicy,
	},
	AppSettingConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppSettingConnectionKeySpecifier | (() => undefined | AppSettingConnectionKeySpecifier),
		fields?: AppSettingConnectionFieldPolicy,
	},
	AppSettingEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppSettingEdgeKeySpecifier | (() => undefined | AppSettingEdgeKeySpecifier),
		fields?: AppSettingEdgeFieldPolicy,
	},
	BlogCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BlogCategoryKeySpecifier | (() => undefined | BlogCategoryKeySpecifier),
		fields?: BlogCategoryFieldPolicy,
	},
	BlogCategoryConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BlogCategoryConnectionKeySpecifier | (() => undefined | BlogCategoryConnectionKeySpecifier),
		fields?: BlogCategoryConnectionFieldPolicy,
	},
	BlogCategoryEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BlogCategoryEdgeKeySpecifier | (() => undefined | BlogCategoryEdgeKeySpecifier),
		fields?: BlogCategoryEdgeFieldPolicy,
	},
	BlogPost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BlogPostKeySpecifier | (() => undefined | BlogPostKeySpecifier),
		fields?: BlogPostFieldPolicy,
	},
	BlogPostConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BlogPostConnectionKeySpecifier | (() => undefined | BlogPostConnectionKeySpecifier),
		fields?: BlogPostConnectionFieldPolicy,
	},
	BlogPostEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BlogPostEdgeKeySpecifier | (() => undefined | BlogPostEdgeKeySpecifier),
		fields?: BlogPostEdgeFieldPolicy,
	},
	DeleteAppSetting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteAppSettingKeySpecifier | (() => undefined | DeleteAppSettingKeySpecifier),
		fields?: DeleteAppSettingFieldPolicy,
	},
	DeleteBlogCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteBlogCategoryKeySpecifier | (() => undefined | DeleteBlogCategoryKeySpecifier),
		fields?: DeleteBlogCategoryFieldPolicy,
	},
	DeleteBlogPost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteBlogPostKeySpecifier | (() => undefined | DeleteBlogPostKeySpecifier),
		fields?: DeleteBlogPostFieldPolicy,
	},
	DeleteGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteGroupKeySpecifier | (() => undefined | DeleteGroupKeySpecifier),
		fields?: DeleteGroupFieldPolicy,
	},
	DeleteMart?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteMartKeySpecifier | (() => undefined | DeleteMartKeySpecifier),
		fields?: DeleteMartFieldPolicy,
	},
	DeleteMenu?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteMenuKeySpecifier | (() => undefined | DeleteMenuKeySpecifier),
		fields?: DeleteMenuFieldPolicy,
	},
	DeletePaymentMethod?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeletePaymentMethodKeySpecifier | (() => undefined | DeletePaymentMethodKeySpecifier),
		fields?: DeletePaymentMethodFieldPolicy,
	},
	DeleteProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteProductKeySpecifier | (() => undefined | DeleteProductKeySpecifier),
		fields?: DeleteProductFieldPolicy,
	},
	DeleteProductCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteProductCategoryKeySpecifier | (() => undefined | DeleteProductCategoryKeySpecifier),
		fields?: DeleteProductCategoryFieldPolicy,
	},
	DeleteUserNode?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteUserNodeKeySpecifier | (() => undefined | DeleteUserNodeKeySpecifier),
		fields?: DeleteUserNodeFieldPolicy,
	},
	Group?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupKeySpecifier | (() => undefined | GroupKeySpecifier),
		fields?: GroupFieldPolicy,
	},
	GroupConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupConnectionKeySpecifier | (() => undefined | GroupConnectionKeySpecifier),
		fields?: GroupConnectionFieldPolicy,
	},
	GroupEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupEdgeKeySpecifier | (() => undefined | GroupEdgeKeySpecifier),
		fields?: GroupEdgeFieldPolicy,
	},
	LoginFacebookUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LoginFacebookUserKeySpecifier | (() => undefined | LoginFacebookUserKeySpecifier),
		fields?: LoginFacebookUserFieldPolicy,
	},
	LoginGoogleUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LoginGoogleUserKeySpecifier | (() => undefined | LoginGoogleUserKeySpecifier),
		fields?: LoginGoogleUserFieldPolicy,
	},
	Mart?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MartKeySpecifier | (() => undefined | MartKeySpecifier),
		fields?: MartFieldPolicy,
	},
	MartConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MartConnectionKeySpecifier | (() => undefined | MartConnectionKeySpecifier),
		fields?: MartConnectionFieldPolicy,
	},
	MartEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MartEdgeKeySpecifier | (() => undefined | MartEdgeKeySpecifier),
		fields?: MartEdgeFieldPolicy,
	},
	Menu?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuKeySpecifier | (() => undefined | MenuKeySpecifier),
		fields?: MenuFieldPolicy,
	},
	MenuConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuConnectionKeySpecifier | (() => undefined | MenuConnectionKeySpecifier),
		fields?: MenuConnectionFieldPolicy,
	},
	MenuEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuEdgeKeySpecifier | (() => undefined | MenuEdgeKeySpecifier),
		fields?: MenuEdgeFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	Node?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NodeKeySpecifier | (() => undefined | NodeKeySpecifier),
		fields?: NodeFieldPolicy,
	},
	PageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageInfoKeySpecifier | (() => undefined | PageInfoKeySpecifier),
		fields?: PageInfoFieldPolicy,
	},
	PasswordReset?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PasswordResetKeySpecifier | (() => undefined | PasswordResetKeySpecifier),
		fields?: PasswordResetFieldPolicy,
	},
	PaymentMethod?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentMethodKeySpecifier | (() => undefined | PaymentMethodKeySpecifier),
		fields?: PaymentMethodFieldPolicy,
	},
	PaymentMethodConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentMethodConnectionKeySpecifier | (() => undefined | PaymentMethodConnectionKeySpecifier),
		fields?: PaymentMethodConnectionFieldPolicy,
	},
	PaymentMethodEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentMethodEdgeKeySpecifier | (() => undefined | PaymentMethodEdgeKeySpecifier),
		fields?: PaymentMethodEdgeFieldPolicy,
	},
	PaymentMethodTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentMethodTranslationKeySpecifier | (() => undefined | PaymentMethodTranslationKeySpecifier),
		fields?: PaymentMethodTranslationFieldPolicy,
	},
	Permission?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PermissionKeySpecifier | (() => undefined | PermissionKeySpecifier),
		fields?: PermissionFieldPolicy,
	},
	Product?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductKeySpecifier | (() => undefined | ProductKeySpecifier),
		fields?: ProductFieldPolicy,
	},
	ProductCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCategoryKeySpecifier | (() => undefined | ProductCategoryKeySpecifier),
		fields?: ProductCategoryFieldPolicy,
	},
	ProductCategoryConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCategoryConnectionKeySpecifier | (() => undefined | ProductCategoryConnectionKeySpecifier),
		fields?: ProductCategoryConnectionFieldPolicy,
	},
	ProductCategoryEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCategoryEdgeKeySpecifier | (() => undefined | ProductCategoryEdgeKeySpecifier),
		fields?: ProductCategoryEdgeFieldPolicy,
	},
	ProductCategoryTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCategoryTranslationKeySpecifier | (() => undefined | ProductCategoryTranslationKeySpecifier),
		fields?: ProductCategoryTranslationFieldPolicy,
	},
	ProductConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductConnectionKeySpecifier | (() => undefined | ProductConnectionKeySpecifier),
		fields?: ProductConnectionFieldPolicy,
	},
	ProductEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductEdgeKeySpecifier | (() => undefined | ProductEdgeKeySpecifier),
		fields?: ProductEdgeFieldPolicy,
	},
	ProductTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductTranslationKeySpecifier | (() => undefined | ProductTranslationKeySpecifier),
		fields?: ProductTranslationFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	RefreshToken?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefreshTokenKeySpecifier | (() => undefined | RefreshTokenKeySpecifier),
		fields?: RefreshTokenFieldPolicy,
	},
	Register?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegisterKeySpecifier | (() => undefined | RegisterKeySpecifier),
		fields?: RegisterFieldPolicy,
	},
	ResendActivationEmail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ResendActivationEmailKeySpecifier | (() => undefined | ResendActivationEmailKeySpecifier),
		fields?: ResendActivationEmailFieldPolicy,
	},
	SaveAppSetting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaveAppSettingKeySpecifier | (() => undefined | SaveAppSettingKeySpecifier),
		fields?: SaveAppSettingFieldPolicy,
	},
	SaveBlogCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaveBlogCategoryKeySpecifier | (() => undefined | SaveBlogCategoryKeySpecifier),
		fields?: SaveBlogCategoryFieldPolicy,
	},
	SaveBlogPost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaveBlogPostKeySpecifier | (() => undefined | SaveBlogPostKeySpecifier),
		fields?: SaveBlogPostFieldPolicy,
	},
	SaveGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaveGroupKeySpecifier | (() => undefined | SaveGroupKeySpecifier),
		fields?: SaveGroupFieldPolicy,
	},
	SaveMart?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaveMartKeySpecifier | (() => undefined | SaveMartKeySpecifier),
		fields?: SaveMartFieldPolicy,
	},
	SaveMenu?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaveMenuKeySpecifier | (() => undefined | SaveMenuKeySpecifier),
		fields?: SaveMenuFieldPolicy,
	},
	SavePaymentMethod?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SavePaymentMethodKeySpecifier | (() => undefined | SavePaymentMethodKeySpecifier),
		fields?: SavePaymentMethodFieldPolicy,
	},
	SaveProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaveProductKeySpecifier | (() => undefined | SaveProductKeySpecifier),
		fields?: SaveProductFieldPolicy,
	},
	SaveProductCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaveProductCategoryKeySpecifier | (() => undefined | SaveProductCategoryKeySpecifier),
		fields?: SaveProductCategoryFieldPolicy,
	},
	SaveUserNode?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaveUserNodeKeySpecifier | (() => undefined | SaveUserNodeKeySpecifier),
		fields?: SaveUserNodeFieldPolicy,
	},
	SendPasswordResetEmail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendPasswordResetEmailKeySpecifier | (() => undefined | SendPasswordResetEmailKeySpecifier),
		fields?: SendPasswordResetEmailFieldPolicy,
	},
	SetPermissionsForGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SetPermissionsForGroupKeySpecifier | (() => undefined | SetPermissionsForGroupKeySpecifier),
		fields?: SetPermissionsForGroupFieldPolicy,
	},
	TokenAuth?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TokenAuthKeySpecifier | (() => undefined | TokenAuthKeySpecifier),
		fields?: TokenAuthFieldPolicy,
	},
	UserNode?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserNodeKeySpecifier | (() => undefined | UserNodeKeySpecifier),
		fields?: UserNodeFieldPolicy,
	},
	UserNodeConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserNodeConnectionKeySpecifier | (() => undefined | UserNodeConnectionKeySpecifier),
		fields?: UserNodeConnectionFieldPolicy,
	},
	UserNodeEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserNodeEdgeKeySpecifier | (() => undefined | UserNodeEdgeKeySpecifier),
		fields?: UserNodeEdgeFieldPolicy,
	},
	VerifyAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VerifyAccountKeySpecifier | (() => undefined | VerifyAccountKeySpecifier),
		fields?: VerifyAccountFieldPolicy,
	},
	VerifyToken?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VerifyTokenKeySpecifier | (() => undefined | VerifyTokenKeySpecifier),
		fields?: VerifyTokenFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;